import { ENTRY_TYPE_DRAFT, ENTRY_TYPE_SERVICE, hourFields } from '../config/staticValues';

export const getProcHoursBreakdown = (entries) => {
  const serviceHours =
    entries.length > 0
      ? Number.parseFloat(
          entries
            .reduce(
              (total, entry) =>
                total +
                (entry.type?.toUpperCase() === ENTRY_TYPE_SERVICE ||
                entry.type?.toUpperCase() === ENTRY_TYPE_DRAFT
                  ? entry.hours
                  : 0),
              0
            )
            .toFixed(2)
        )
      : 0;
  return { serviceHours };
};

export const getClockedHoursTotal = (workday) =>
  hourFields.length > 0
    ? Number.parseFloat(
        hourFields
          .reduce(
            (total, field) => total + (workday[field.id] ? workday[field.id] : 0),
            0
          )
          .toFixed(2)
      )
    : 0;

export const sumProperty = (data, field) =>
  data && data.length > 0
    ? Number.parseFloat(
        data.reduce((total, row) => total + (row[field] ? row[field] : 0), 0).toFixed(2)
      )
    : 0;

export const formatDollars = (amount) => {
  return amount ? '$' + amount.toFixed(2) : '$0.00';
};

export const formatHours = (hours) => {
  return hours ? Number.parseFloat(hours).toFixed(2) : '0.00';
};

export const isAndroid = () => {
  if (typeof navigator === "undefined") return false;
  return /Android/i.test(navigator.userAgent);
};

